module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["更换手机号码"]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right",
    on: {
      "click": function($event) {
        _vm.updatePhone()
      }
    }
  }, ["确定"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page class-edit"
  }, [_vm._h('p', {
    staticClass: "margin-15"
  }, ["您当前使用的手机号码是：" + _vm._s(_vm.now_phone_num)]), " ", _vm._h('div', {
    staticClass: "telephone-change"
  }, [_vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["+86"]), " ", _vm._h('span', {
    staticClass: "block"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_num),
      expression: "phone_num"
    }],
    staticClass: "margin-x-15 font-14",
    attrs: {
      "type": "number",
      "placeholder": "请填写新手机号码"
    },
    domProps: {
      "value": _vm._s(_vm.phone_num)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_num = _vm._n($event.target.value)
      }
    }
  })])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "block"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check_code),
      expression: "check_code"
    }],
    staticClass: "font-14",
    attrs: {
      "type": "number",
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": _vm._s(_vm.check_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.check_code = _vm._n($event.target.value)
      }
    }
  })]), " ", (_vm.code_sec_msg = '获取验证码') ? _vm._h('a', {
    staticClass: "yzm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getCheckCode($event)
      }
    }
  }, [_vm._s(_vm.code_sec_msg)]) : _vm._h('a', {
    staticClass: "yzm gray"
  }, [_vm._s(_vm.code_sec_msg)]), " "])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-0766ffc8!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/userCollection/UpdatePhone.vue
// module id = 173
// module chunks = 1